import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-subexpcvdvreport',

  templateUrl: './subexpcvdvreport.component.html',
  styleUrl: './subexpcvdvreport.component.scss'
})
export class SubexpcvdvreportComponent {
  mainexp: any;
  subexp: any;
  startDate: any;
  endDate: any;
  allvoucherdata: any;
  dr_opening_bal: any;
  currentDate: Date;
  exp_name: any;
  cr_opening_bal: any;
  alldebitvoucher2: any[];
  alldebitvoucher11: any[];


  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<SubexpcvdvreportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
  ) {

  }

  ngOnInit(): void {
    this.currentDate = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.mainexp = this.data['mainexp'];
    this.subexp = this.data['subexp'];
    this.getSubExpenseEedgeCvDvReport();
  }

  getFormattedDate(): string {
    return this.datePipe.transform(this.currentDate, 'dd-MM-yyyy');
  }

  alldebitvoucher: any
  alldebitvoucher1: any
  getSubExpenseEedgeCvDvReport() {
    this.alldebitvoucher1 = [];

    const subexpid = this.subexp
      .map((id: any) => id)
      .filter((id: any) => id != null)
      .join(",");

    if (this.startDate === '2024-04-01') {

      const startDate = this.datePipe.transform(this.startDate, 'yyyy-MM-dd');
      const endDate = this.datePipe.transform(this.endDate, 'yyyy-MM-dd');

      this.getReport(startDate, endDate);

    } else {

      const fyStart = '2024-04-01';

      const prevDate = new Date(this.startDate);
      prevDate.setDate(prevDate.getDate() - 1);

      const startDate = fyStart;
      const endDate = this.datePipe.transform(prevDate, 'yyyy-MM-dd');

      this.getReport(startDate, endDate);

    }

  }

  getReport(startdate: any, enddate: any) {

    debugger

    const startDate1 = this.datePipe.transform(this.startDate, 'yyyy-MM-dd');
    const endDate1 = this.datePipe.transform(this.endDate, 'yyyy-MM-dd');

    this.alldebitvoucher1 = [];
    this.alldebitvoucher11 = [];

    const subexpid = this.subexp
      .map((id: any) => id)
      .filter((id: any) => id != null)
      .join(",");

    const cv: any = {
      exp_id: this.mainexp,
      sub_exp_ids: subexpid,
      startdate: startdate,
      enddate: enddate,
    };

    this.service.getSubExpenseEedgeCvDvReport(cv).subscribe((a) => {
      this.alldebitvoucher = a;

      this.alldebitvoucher.forEach((element) => {
        const drAddition = Number(element.dr_opening_bal) + Number(element.total_debit_amount);
        const crAddition = Number(element.cr_opening_bal) + Number(element.total_credit_amount);

        if (Math.abs(drAddition) > Math.abs(crAddition)) {
          element.total_debit_amount = (drAddition + crAddition).toFixed(2);
          element.total_credit_amount = 0.00.toFixed(2);
        } else {
          element.total_credit_amount = (drAddition + crAddition).toFixed(2);
          element.total_debit_amount = 0.00.toFixed(2);
        }

        // Only push if at least one of the two is non-zero
        if (element.total_debit_amount !== '0.00' || element.total_credit_amount !== '0.00') {
          this.alldebitvoucher1.push(element);
        }
        this.alldebitvoucher11.push(element);
      });

      if (this.alldebitvoucher.length > 0) {
        this.exp_name = this.alldebitvoucher[0].exp_name;
      }

      if (this.startDate !== '2024-04-01') {
        this.getFinalReport(startDate1, endDate1, this.alldebitvoucher11);
      }

    });

  }

  getFinalReport(startdate: any, enddate: any, alldebitvoucher1: any[]) {

    this.alldebitvoucher2 = [];
    this.alldebitvoucher = [];

    const subexpid = this.subexp
      .filter((id: any) => id != null)
      .join(',');

    const cv = {
      exp_id: this.mainexp,
      sub_exp_ids: subexpid,
      startdate,
      enddate
    };

    this.service.getSubExpenseEedgeCvDvReport(cv)
      .subscribe((response: any[]) => {

        this.alldebitvoucher = response;

        this.alldebitvoucher.forEach((element, index) => {

          // 🔹 Opening from alldebitvoucher1
          const openingDr = Number(alldebitvoucher1[index]?.total_debit_amount || 0);
          const openingCr = Number(alldebitvoucher1[index]?.total_credit_amount || 0);

          // 🔹 Current period amounts
          const periodDr = Number(element.total_debit_amount || 0);
          const periodCr = Number(element.total_credit_amount || 0);

          console.log('openingDr:', openingDr);
          console.log('openingCr:', openingCr);
          console.log('periodDr:', periodDr);
          console.log('periodCr:', periodCr);

          const drAddition = Math.abs(openingDr + periodDr);
          const crAddition = openingCr + periodCr;

          console.log('drAddition:', drAddition);
          console.log('crAddition:', crAddition);

          if (drAddition > crAddition) {
            element.total_debit_amount = (drAddition - crAddition).toFixed(2);
            element.total_credit_amount = '0.00';
          } else {
            element.total_credit_amount = (crAddition - drAddition).toFixed(2);
            element.total_debit_amount = '0.00';
          }

          // Only push if at least one of the two is non-zero
          if (element.total_debit_amount !== '0.00' || element.total_credit_amount !== '0.00') {
            this.alldebitvoucher2.push(element);
          }

        });

        this.alldebitvoucher1 = [...this.alldebitvoucher2];

        if (this.alldebitvoucher2.length > 0) {
          this.exp_name = this.alldebitvoucher2[0].exp_name;
        }
      });
  }

  getTotalDebit(): number {
    return this.alldebitvoucher1.reduce((sum, item) => sum + (parseFloat(item.total_debit_amount) || 0), 0);
  }

  getTotalCredit(): number {
    return this.alldebitvoucher1.reduce((sum, item) => sum + (parseFloat(item.total_credit_amount) || 0), 0);
  }


}